(function () {
  document.querySelectorAll('[data-sablon]').forEach(function (root) {
    var data = root.querySelector('[data-sb-variants]');
    var idField = root.querySelector('[data-sb-variant-id]');
    var priceEl = root.querySelector('[data-sb-price]');
    var submit = root.querySelector('[data-sb-submit]');
    if (!data || !idField) return;

    var ctaText = root.dataset.sbCta || 'Add to bag';
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var prices = {};
    try { prices = JSON.parse((root.querySelector('[data-sb-prices]') || {}).textContent || '{}'); } catch (e) {}

    var sticky = root.querySelector('[data-sb-sticky]');
    var stickySubmit = root.querySelector('[data-sb-sticky-submit]');
    var stickyPrice = root.querySelector('[data-sb-sticky-price]');
    var stickyFinish = root.querySelector('[data-sb-sticky-finish]');

    var gallery = root.querySelector('[data-sb-gallery]');
    var shots = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-sb-finish]')) : [];

    function selected() {
      var out = [];
      root.querySelectorAll('.sb-radio:checked').forEach(function (r) {
        out[parseInt(r.dataset.sbOptIndex, 10)] = r.value;
      });
      return out;
    }

    function match(sel) {
      return variants.filter(function (v) {
        return sel.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }


    /* The gallery is one list in the DOM; picking a finish hides the shots that
       belong to the other one. 'any' shots (sizing diagrams and the like) stay
       visible for both. If a finish somehow has no shots of its own, nothing is
       hidden — an empty gallery is worse than a mixed one. */
    function showFinish(finish) {
      if (!shots.length || !finish) return;
      var key = String(finish).toLowerCase();
      var hasOwn = shots.some(function (s) { return s.dataset.sbFinish === key; });
      if (!hasOwn) key = null;
      shots.concat(Array.prototype.slice.call(root.querySelectorAll('[data-sb-thumb]'))).forEach(function (s) {
        var f = s.dataset.sbFinish;
        s.hidden = key ? (f !== key && f !== 'any') : false;
      });
      /* On desktop the first shot spans both grid columns; only do that when
         the visible count is odd so the 2-up grid never ends on an orphan. */
      var visible = shots.filter(function (s) { return !s.hidden; });
      var lead = visible.length % 2 === 1 ? visible[0] : null;
      shots.forEach(function (s) { s.classList.toggle('is-lead', s === lead); });
      tabStop();
      if (gallery) { gallery.scrollTop = 0; gallery.scrollLeft = 0; }
    }

    function tabStop() {
      var first = shots.filter(function (s) { return !s.hidden; })[0];
      shots.forEach(function (s) { if (s.hasAttribute('role')) s.tabIndex = s === first ? 0 : -1; });
    }

    function finishValue() {
      var r = root.querySelector('.sb-radio[data-sb-opt-name="finish"]:checked');
      return r ? r.value : null;
    }

    function sync() {
      showFinish(finishValue());
      if (stickyFinish && finishValue()) stickyFinish.textContent = finishValue();

      var v = match(selected());
      if (!v) {
        setButtons(true, 'Unavailable');
        return;
      }
      idField.value = v.id;
      /* Keep the URL on the chosen variant so a shared gold link opens gold.
         replaceState, not pushState: picking options shouldn't fill the back button. */
      if (synced && window.history && history.replaceState) {
        try {
          var u = new URL(location.href);
          if (u.searchParams.get('variant') !== String(v.id)) { u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); }
        } catch (e) {}
      }
      /* Prices come pre-formatted from Liquid (data-sb-prices), so every market shows its
         own currency correctly ("$32.00 USD"); the browser never guesses a format. */
      var fp = prices[String(v.id)];
      if (fp) {
        if (priceEl) priceEl.textContent = fp.p;
        if (stickyPrice) stickyPrice.textContent = fp.p;
        root.querySelectorAll('[data-sb-per]').forEach(function (el) { el.textContent = fp.e + ' each'; });
      }
      setButtons(!v.available, v.available ? ctaText : 'Sold out');
    }

    function setButtons(disabled, label) {
      [submit, stickySubmit].forEach(function (b) {
        if (!b) return;
        b.disabled = disabled;
        b.textContent = label;
      });
    }

    /* Mobile sticky bar: visible while the main button is out of view, hidden
       when it is on screen. CSS keeps it off on desktop.
       While it shows, its measured height is published as --sb-bar-h and html gets
       .sb-bar-on, so the page reserves that space at the bottom (padding + scroll-padding)
       and nothing focused or scrolled-to ends up behind the bar. */
    if (sticky && submit && 'IntersectionObserver' in window) {
      var docEl = document.documentElement;
      var barH = function () { return Math.ceil(sticky.getBoundingClientRect().height) || 64; };
      var setH = function () { docEl.style.setProperty('--sb-bar-h', barH() + 'px'); };
      setH();
      if ('ResizeObserver' in window) new ResizeObserver(setH).observe(sticky);
      var mobile = window.matchMedia('(max-width: 899px)');
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          /* First touch: show it whenever the main button is off screen, above or
             below, so a cold mobile visitor has a buy button in the first viewport.
             The bottom root margin is the bar's own height: a main button sitting
             behind the bar counts as off screen. */
          var show = !(e.isIntersecting && e.intersectionRatio >= 0.6);
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          docEl.classList.toggle('sb-bar-on', show && mobile.matches);
          if (stickySubmit) stickySubmit.tabIndex = show ? 0 : -1;
        });
      }, { threshold: 0.6, rootMargin: '0px 0px -' + barH() + 'px 0px' }).observe(submit);
      /* Keyboard focus never lands behind the bar (WCAG 2.4.11). */
      document.addEventListener('focusin', function (ev) {
        if (!sticky.classList.contains('is-visible') || sticky.contains(ev.target)) return;
        var r = ev.target.getBoundingClientRect(), top = sticky.getBoundingClientRect().top;
        if (r.bottom > top - 8 && r.top < window.innerHeight) window.scrollBy(0, r.bottom - top + 16);
      });
    }

    /* In-page links to an accordion ("Find your size", returns "Details") open it. */
    root.querySelectorAll('a[href^="#sablon-"]').forEach(function (a) {
      a.addEventListener('click', function () {
        var d = document.getElementById(a.getAttribute('href').slice(1));
        if (d && d.tagName === 'DETAILS') d.open = true;
      });
    });


    /* Mobile thumbnails: tap to jump, and mark the one in view. */
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sb-thumb]'));
    if (thumbs.length && gallery) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var shot = gallery.querySelector('[data-sb-shot="' + t.dataset.sbThumb + '"]');
          if (shot) gallery.scrollTo({ left: shot.offsetLeft - gallery.offsetLeft - 16, behavior: 'smooth' });
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var n = e.target.dataset.sbShot;
            thumbs.forEach(function (t) { t.classList.toggle('is-current', t.dataset.sbThumb === n); });
          });
        }, { root: gallery, threshold: 0.6 });
        shots.forEach(function (s) { io.observe(s); });
      }
    }

    root.querySelectorAll('.sb-radio').forEach(function (r) {
      r.addEventListener('change', sync);
    });
    var synced = false;
    sync();
    synced = true;

    /* Arriving on #sablon-sizing (menu/footer "Sizing guide") or #sablon-returns
       opens that accordion and brings it into view. */
    function openFromHash() {
      var id = location.hash.slice(1);
      if (id.indexOf('sablon-') !== 0) return;
      var d = document.getElementById(id);
      if (d && d.tagName === 'DETAILS') { d.open = true; setTimeout(function () { d.scrollIntoView({ block: 'start' }); }, 60); }
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);

    /* Image zoom: tap or Enter on a gallery shot opens a full-screen viewer
       (swipe or arrow keys between shots, pinch to zoom on phones, Esc to close). */
    if (gallery && 'HTMLDialogElement' in window) {
      var dlg = null, track = null;
      function big(img) {
        var best = img.currentSrc || img.src, w = 0;
        (img.getAttribute('srcset') || '').split(',').forEach(function (c) {
          var bits = c.trim().split(/\s+/), n = parseInt(bits[1], 10);
          if (n > w) { w = n; best = bits[0]; }
        });
        return best;
      }
      function build() {
        dlg = document.createElement('dialog');
        dlg.className = 'sb-zoom';
        dlg.setAttribute('aria-label', 'Product images');
        dlg.innerHTML = '<button type="button" class="sb-zoom__close" aria-label="Close">\u00d7</button><div class="sb-zoom__track" tabindex="0"></div><p class="sb-zoom__count" aria-live="polite"></p>';
        document.body.appendChild(dlg);
        track = dlg.querySelector('.sb-zoom__track');
        dlg.querySelector('.sb-zoom__close').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
        dlg.addEventListener('close', function () { document.documentElement.classList.remove('sb-zoom-open'); });
        track.addEventListener('scroll', function () { count(); }, { passive: true });
        dlg.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: 'smooth' }); }
        });
      }
      function count() {
        var n = track.children.length, i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1;
        dlg.querySelector('.sb-zoom__count').textContent = n > 1 ? Math.min(i, n) + ' / ' + n : '';
      }
      function open(shot) {
        if (!dlg) build();
        var visible = shots.filter(function (s) { return !s.hidden && s.querySelector('img'); });
        track.innerHTML = '';
        visible.forEach(function (s) {
          var img = s.querySelector('img'), fig = document.createElement('figure'), im = document.createElement('img');
          im.src = big(img); im.alt = img.alt || ''; im.decoding = 'async';
          fig.appendChild(im); track.appendChild(fig);
        });
        document.documentElement.classList.add('sb-zoom-open');
        dlg.showModal();
        var idx = Math.max(0, visible.indexOf(shot));
        track.scrollLeft = idx * track.clientWidth;
        count();
        track.focus({ preventScroll: true });
      }
      shots.forEach(function (s, i) {
        if (!s.querySelector('img')) return;
        s.setAttribute('role', 'button');
        /* One tab stop for the gallery (the first shot); the viewer's arrow keys
           reach the rest, so keyboard users aren't walked through every image. */
        s.setAttribute('tabindex', '-1');
        s.setAttribute('aria-label', 'View images larger, starting with image ' + (i + 1) + '. Arrow keys move between images.');
        s.addEventListener('click', function () { open(s); });
        s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(s); } });
      });
      tabStop();
    }
  });
})();
